// Tags that render something visible even when they hold no text.
const MEDIA_TAG = /<(img|iframe|video|svg|picture)\b/i;

/**
 * Whether a CMS HTML string would render any visible content.
 * Rich-text editors save a cleared field as markup like `<p></p>` or `<p>&nbsp;</p>`,
 * which is truthy but renders nothing. String-only, so it is safe on SSR.
 */
export default function hasVisibleHtmlText(html: unknown): boolean {
  if (typeof html !== "string" || !html) return false;
  if (MEDIA_TAG.test(html)) return true;

  const text = html
    .replace(/<!--[\s\S]*?-->/g, "")
    .replace(/<(script|style)\b[\s\S]*?<\/\1\s*>/gi, "")
    .replace(/<[^>]*>/g, "")
    .replace(/&(nbsp|#160|#x0*a0|zwnj|zwj|#8203|#x200b);/gi, "")
    .replace(/[\s\u00a0\u200b-\u200d\u2060\ufeff]/g, "");

  return text.length > 0;
}
